import { render, staticRenderFns } from "./RapidCreditTag.vue?vue&type=template&id=71dfca7c"
import script from "./RapidCreditTag.vue?vue&type=script&lang=js"
export * from "./RapidCreditTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports